import { createRoute } from './Route';
import { SimpleSubscription, createOrPassthroughObserver } from './Observable';

var RouteObservable =
/** @class */
function () {
  function RouteObservable(url, env, pages, resolver, withContent) {
    var _this = this;

    this.handleUnsubscribe = function (observer) {
      var index = _this.observers.indexOf(observer);

      if (index !== -1) {
        _this.observers.splice(index, 1);
      }
    };

    this.handleChange = function () {
      _this.refresh();

      for (var i = 0; i < _this.observers.length; i++) {
        var observer = _this.observers[i];
        observer.next(_this.cachedValue);

        if (_this.cachedValue.isSteady && observer.complete) {
          observer.complete();
        }
      }

      if (_this.cachedValue.isSteady) {
        _this.resolver.unlisten(_this.handleChange);

        delete _this.matcher;
        delete _this.resolver;
      }
    };

    this.refresh = function () {
      var _a = _this.matcher.getResult(),
          segment = _a.segment,
          resolutionIds = _a.resolutionIds;

      _this.cachedValue = createRoute(_this.url, segment); // This will replace any existing listener and its associated resolvables

      _this.resolver.listen(_this.handleChange, resolutionIds);
    };

    this.url = url;
    this.resolver = resolver;
    this.observers = [];
    this.matcher = new pages({
      appendFinalSlash: true,
      env: env,
      resolver: this.resolver,
      withContent: withContent
    });
  }

  RouteObservable.prototype.subscribe = function (onNextOrObserver, onError, onComplete) {
    if (!this.resolver) {
      throw new Error("Can't subscribe to an already-complete RoutingObservable.");
    }

    var observer = createOrPassthroughObserver(onNextOrObserver, onError, onComplete);
    this.observers.push(observer);
    var subscription = new SimpleSubscription(this.handleUnsubscribe, observer);

    if (this.observers.length === 1) {
      this.handleChange();
    }

    return subscription;
  };

  return RouteObservable;
}();

export { RouteObservable };